import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "w90 pad15 mt20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "2段階認証を有効"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt30" }, [
    /*#__PURE__*/_createTextVNode(" GoogleAuthenticatorを利用して、ログイン時に二段階認証を行います。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://support.google.com/accounts/answer/10664473?hl=ja",
      target: "_blank"
    }, "GoogleAuthenticatorの使い方")
  ])
], -1)
const _hoisted_7 = { class: "fl w65" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "w90 pad15 mt20"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "2段階認証の設定"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt30" }, " GoogleAuthenticatorまたはMicrosoftAuthenticatorでQRコードをスキャンし、表示される6桁の数字を入力してください。 ")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "fl w65"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_UserSettingsHeader = _resolveComponent("UserSettingsHeader")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_UrlWithQRcodeContent = _resolveComponent("UrlWithQRcodeContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `settings` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_UserSettingsHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _createElementVNode("div", null, [
                _createElementVNode("section", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_SelectTag, {
                      name: "mail_style",
                      id: "mail_style",
                      class: "fl fs14 roundForm",
                      style: {"min-width":"130px","height":"50px","margin-top":"10px"},
                      options: ['有効', '無効'],
                      defaultOption: _ctx.defaultSecurityType(),
                      onSelectValue: _ctx.selectSecurityType
                    }, null, 8, ["defaultOption", "onSelectValue"])
                  ]),
                  _hoisted_8
                ]),
                (_ctx.challengeCode)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                      _hoisted_10,
                      (_ctx.qrCodeUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_UrlWithQRcodeContent, {
                              url: _ctx.qrCodeUrl,
                              index: 1000,
                              hideUrl: true
                            }, null, 8, ["url"]),
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.totpCode) = $event)),
                                type: "text",
                                placeholder: "6桁のコードを入力",
                                maxlength: "6"
                              }, null, 512), [
                                [_vModelText, _ctx.totpCode]
                              ]),
                              _createElementVNode("button", {
                                type: "submit",
                                class: "pointer centered circle_button skyblueBg fs14 rad8 ml20 mt15",
                                style: {"width":"100px","height":"50px","padding":"14px 8px"},
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.verifyTotp && _ctx.verifyTotp(...args)))
                              }, " コードを検証 ")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_12
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_13,
                _hoisted_14
              ]),
              _hoisted_15
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_16
    ])
  ]))
}